import { DefaultTheme } from 'styled-components';
import {
  BlueSkyColors,
  GreyWarmColors,
  PrimaryColors,
  SecondaryColors,
} from './color';

const primaryColors: PrimaryColors = {
  black: '#222222',
  white: '#FFFFFF',
  yellow: 'FFD800',
  blueDark: '#001F4B',
  cyan: '#0693CA',
  cyanHover: '#077AB7',
};
const secondaryColors: SecondaryColors = {
  purple: '#643C73',
  pink: '#E6007E',
  bordeaux: '#982837',
  red: '#DB392A',
  orange: '#F39900',
  apple: '#CDCD00',
  grayTaupe: '#BEA587',
  green: '#46BE41',
  turqoise: '#007E91',
  blueLight: '#73BEE6',
  serviceBlue: '#0A4691',
  grayDark: '#696E7D',
};

const greyWarmColors: GreyWarmColors = {
  100: '#7F756C',
  80: '#99918A',
  60: '#B3ADA7',
  40: '#CCC8C5',
  20: '#E6E4E2',
  10: '#F2F1F1',
};

const blueSkyColors: BlueSkyColors = {
  100: '#C2DEEA',
  75: '#D2E7F0',
  50: '#E0EEF4',
  25: '#F0F7FA',
  10: '#F8FBFC',
};

const lightTheme: DefaultTheme = {
  mode: 'light',
  colors: {
    white: '#FFFFFF',
    lightestGray: '#f6f9fc',
    lightGrey: '#DADADA',
    textGrey: '#8C8C8C',
    grey: '#4F4F4F',
    midGrey: '#2F2F2F',
    darkGrey: '#1E2022',
    linearGradient: '#1D1D1D',
    lightBlue: '#0693C9',
    midBlue: '#0485BA',
    darkBlue: '#001F4B',
    green: '#45BE41',
    orange: '#F39902',
    red: '#DB3A2A',
    primary: primaryColors,
    secondary: secondaryColors,
    greyWarm: greyWarmColors,
    blueSky: blueSkyColors,
    text: {
      primary: '#001F4B',
      secondary: '#8C8C8C',
    },
    outline: {
      primary: '#DADADA',
    },
  },
  typography: {
    primary: {
      regular: 'NLRTM',
      bold: 'NLRTM-Bold',
    },
  },
  spacing: {
    '2px': '2px',
    '4px': '4px',
    '8px': '8px',
    '16px': '16px',
    '32px': '32px',
  },
  radius: {
    '3px': '3px',
    '6px': '6px',
    '9px': '9px',
  },
};

export default lightTheme;
